import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import Input from 'form/input';
import Spinner from 'spinner';
import Pagination from 'pagination';
import {List, EmptyList, UniversalSearchWrapper} from 'components/common';
import {ButtonDefault, LinkInfo} from 'components/buttons';

import {searchSubordinateInstitutions} from 'redux/actions/portal/institutions';


const mapStateToProps = (state) => ({
  subordinateInstitutions: state.institutions.get('institutionsSubordinateList'),
  isFetching: state.institutions.get('institutionsIsLoading')
});

const mapDispatchToProps = (dispatch) => ({
  onSearch: (name, id, offset) => {
    dispatch(searchSubordinateInstitutions(name, id, 12, offset))
  }

}); 


class Subordinate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: ""
    }

    this.changeSearchName = this.changeSearchName.bind(this);
  }

  changeSearchName(event) {
    this.setState({
      name: event.target.value
    })
  }
  

  componentDidMount() {
    const page = this.props.match.params.page || 1;
    const offset = 12 * (page - 1);
    this.props.onSearch(this.state.name, this.props.match.params.id, offset)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.page !== nextProps.match.params.page) {
        const page = nextProps.match.params.page || 1;
        const offset = 12 * (page - 1);
      this.props.onSearch(this.state.name, nextProps.match.params.id, offset)
    }
    if (this.props.match.params.id !== nextProps.match.params.id){
      this.props.onSearch(this.state.name, nextProps.match.params.id)
    }
  }

  render() {

    if (this.props.subordinateInstitutions === undefined && this.props.item === undefined) {
      return <Spinner/>
    }

    if (this.props.subordinateInstitutions.get('results').size === 0) {
      return(
        <div>
            <UniversalSearchWrapper onSubmit={(event) => {
          event.preventDefault();
          this.props.onSearch(this.state.name, this.props.match.params.id)
        }}>
          <Input
            block
            placeholder="Введіть назву або код ЄДРПОУ установи"
            label="Пошук за назвою та кодом ЄДРПОУ установи"
            value={this.state.name}
            onChange={this.changeSearchName}
          />
          <ButtonDefault type="submit" value="Пошук" />
          
          </UniversalSearchWrapper>
        <EmptyList>
           <h5>Підпорядковані установи та підрозділи відсутні</h5>
      </EmptyList>
      <div>
       {this.props.detail.get('hierarchy_level') < 3 ?
       <LinkInfo style={{marginLeft: "10px"}}
         to={{
           pathname: `/admin/institutions/create`,
           state: { institution: this.props.match.params.id ,
           institution_title: this.props.detail.get('full_title'),
               short_title: this.props.detail.get('short_title'),
               instType: this.props.detail.get('institution_type')
           }
         }}
       >
         Додати установу
       </LinkInfo>
       :
       null
}
</div>
</div>
      )
    }

    return(
      <div>
          <UniversalSearchWrapper onSubmit={(event) => {
          event.preventDefault();
          this.props.onSearch(this.state.name, this.props.match.params.id)
        }}>
          <Input
            block
            placeholder="Введіть назву або код ЄДРПОУ установи"
            label="Пошук за назвою та кодом ЄДРПОУ установи"
            value={this.state.name}
            onChange={this.changeSearchName}
          />
          <ButtonDefault type="submit" value="Пошук" />
          
          {this.props.detail.get('hierarchy_level') < 3 ?
              <LinkInfo style={{height: "47px", marginTop: "25px"}}
                to={{
                  pathname: `/admin/institutions/create`,
                  state: { institution: this.props.match.params.id ,
                  institution_title: this.props.detail.get('full_title'),
                      short_title: this.props.detail.get('short_title'),
                      instType: this.props.detail.get('institution_type')
                  }
                }}
              >
                Додати установу
              </LinkInfo>
              :
              null
      }
          </UniversalSearchWrapper>
          
        {this.props.subordinateInstitutions.get('results').size > 0 ? (
        <List>
            {this.props.subordinateInstitutions.get('results').map((item, i) => (
            <li key={i}>
                <Link to={`/admin/institutions/detail/${item.get('id')}`}>
                <h5>{item.get('full_title')}</h5>
                <p>{item.get('address')}</p>
                </Link>
            </li>
            ))}
        </List>
      
        ): (
        <EmptyList>
        <h5>Підпорядковані установи та підрозділи відсутні</h5>
        </EmptyList>
        )}
        <Pagination counts={this.props.subordinateInstitutions.get('count')} path={`/admin/institutions/detail/${this.props.match.params.id}/subordinate-institutions/`} matched={this.props.match.params.page} limits={12} />
              
      </div>
    )
  }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Subordinate));


// WEBPACK FOOTER //
// ./src/admin/institutions/subordinate.js